import React from 'react';
import { Formik } from 'formik';
import { Grid, Form, Button, Divider, Radio } from 'semantic-ui-react';
import moment from 'moment';
import PropTypes from 'prop-types';
import Slider from 'rc-slider';
import Tooltip from 'rc-tooltip';
import _ from 'lodash';

import { Column } from 'components/Layout';
import getErrors from 'shared/lib/geterrors';
import { TipoContrattoCollaboratoreService } from 'shared/services/api/listitem';

import { AsyncSelect } from '../../UI/AsyncSelect';
import { DatePicker } from '../../UI/DatePicker';
import { Input, Currency } from '../../UI/Input';

const DividerForm = () => (
  <Column width={16}>
    <Divider fitted style={{ marginLeft: -20, marginRight: -20 }} />
  </Column>
);

const Handle = Slider.Handle;

const handle = (props) => {
  const { value, dragging, index, ...restProps } = props;
  return (
    <Tooltip overlay={value} visible={dragging} placement="top" key={index}>
      <Handle value={value} {...restProps} />
    </Tooltip>
  );
};

// TODO: Aggiungere proptypes corretti
handle.propTypes = {
  value: PropTypes.any,
  dragging: PropTypes.any,
  index: PropTypes.any,
};

// TODO KIR-1919
const ContrattoForm = (props) => (
  <Grid style={{ paddingBottom: 15 }}>
    <Column width={16}>
      <Formik
        initialValues={{
          uuid: props.initialValues ? props.initialValues.uuid : '',
          id: props.initialValues ? props.initialValues.id : '',
          dataDecorrenza: props.initialValues ? props.initialValues.dataDecorrenza : '',
          tipologia: props.initialValues ? props.initialValues.tipologia : '',
          numero: props.initialValues ? props.initialValues.numero : '',
          dataRescissione: props.initialValues ? props.initialValues.dataRescissione : '',
          compensoMensile: props.initialValues ? props.initialValues.compensoMensile : '',
          periodoRimborso: props.initialValues ? props.initialValues.periodoRimborso : '',
          percentualeCaricoKiron: props.initialValues ? props.initialValues.percentualeCaricoKiron : 50,
          attivo: props.initialValues ? props.initialValues.attivo : true,
          isNotNew: props.initialValues ? props.initialValues.isNotNew : false,
        }}
        validate={() => {
          // eslint-disable-line
          // same as above, but feel free to move this into a class method now.
          let errors = {}; // eslint-disable-line
          /* if (!values.email) {
            errors.email = 'Required';
          } else if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
          ) {
            errors.email = 'Invalid email address';
          }*/
          return errors;
        }}
        onSubmit={(
          values,
          { setSubmitting, setErrors /* setValues and other goodies */ } // eslint-disable-line
        ) => {
          setSubmitting(true);
          // console.log("VALORI", values);
          const payload = {
            ...values,
            tipologia: values.tipologia.value ? values.tipologia.value : values.tipologia,
          };

          if (
            payload.tipologia === 'Progetto giovani' &&
            ((!payload.compensoMensile && payload.compensoMensile !== 0) ||
              (!payload.periodoRimborso && payload.periodoRimborso !== 0))
          ) {
            alert('Inserire compenso mensile e periodo di rimborso prima di continuare.'); //eslint-disable-line
            setSubmitting(false);
            return false;
          }

          props.addAction(payload).then(
            // As in prop catch error is handled and not thrown we have to verify status inside .then()
            (data) => {
              setSubmitting(false);
              if (data.status === 200 || data.status === 201 || !data.status) {
                props.closeModal();
              } else {
                const errorsObj = getErrors(data);
                setSubmitting(false);
                setErrors(errorsObj);
              }
            }
          );

          return false;
        }}
        render={({ values, errors, touched, handleSubmit, isSubmitting, setFieldValue, setFieldTouched } = props) => (
          <Form autoComplete="off" onSubmit={handleSubmit} loading={isSubmitting}>
            <Grid>
              <Column width={8}>
                <AsyncSelect
                  loadOptions={() =>
                    TipoContrattoCollaboratoreService.getAllOptions().then((res) => ({
                      options: _.reverse(res.options.map((obj) => ({ label: obj.label, value: obj.label }))),
                    }))
                  }
                  value={values.tipologia}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  style={{ zIndex: 9999 }}
                  error={errors.tipologia}
                  touched={touched.tipologia}
                  name="tipologia"
                  label="Tipologia contratto"
                />
              </Column>
              <Column width={8}>
                <Input label="Numero contratto" touched={touched} errors={errors} name="numero" required />
              </Column>
              <Column width={8}>
                <DatePicker
                  touched={touched}
                  errors={errors}
                  value={values.dataDecorrenza}
                  onChange={setFieldValue}
                  name="dataDecorrenza"
                  label="Data decorrenza"
                  startDate={moment()}
                  openDirection="up"
                />
              </Column>
              <Column width={8}>
                <DatePicker
                  touched={touched}
                  errors={errors}
                  value={values.dataRescissione}
                  onChange={setFieldValue}
                  name="dataRescissione"
                  label="Data rescissione"
                  startDate={moment()}
                  openDirection="up"
                />
              </Column>
              <Column width={8} textAlign="left" verticalAlign="middle" style={{ marginTop: 15 }}>
                <b>Nuovo collaboratore</b>
              </Column>
              <Column width={2} textAlign="right" verticalAlign="middle" style={{ marginTop: 15 }}>
                <Radio
                  toggle
                  checked={!values.isNotNew}
                  onChange={(el, val) => setFieldValue('isNotNew', !val.checked)}
                />
              </Column>
              {values.tipologia &&
                (_.indexOf(['Progetto giovani', 'Progetto START'], values.tipologia.value) !== -1 ||
                  _.indexOf(['Progetto giovani', 'Progetto START'], values.tipologia) !== -1) && [
                    <Column key="titleProgettoGiovani" width={16}>
                      <Divider horizontal>Progetto Giovani</Divider>
                    </Column>,
                    <Column key="progettoGiovaniCompensoMensile" width={8}>
                      <Currency
                        setFieldValue={setFieldValue}
                        values={values}
                        touched={touched}
                        errors={errors}
                        label="Compenso mensile"
                        name="compensoMensile"
                        required
                      />
                    </Column>,
                    <Column key="progettoGiovaniPeriodoRimborso" width={8}>
                      <Input
                        touched={touched}
                        errors={errors}
                        label="Periodo rimborso (mesi)"
                        name="periodoRimborso"
                        required
                      />
                    </Column>,
                    <Column width={16} key="percentualeKironProgettoGiovani">
                      <Form.Field>
                        <label htmlFor="slider">Percentuale carico Kiron: {values.percentualeCaricoKiron}%</label>
                        <Slider
                          onAfterChange={(val) => setFieldValue('percentualeCaricoKiron', val)}
                          min={0}
                          max={100}
                          defaultValue={50}
                          handle={handle}
                        />
                      </Form.Field>
                    </Column>,
                  ]}
              <DividerForm />
              <Column width={16} textAlign="center">
                <Button disabled={isSubmitting} primary style={{ marginTop: 7 }}>
                  {props.initialValues && props.initialValues.id ? 'Modifica' : 'Aggiungi'}
                </Button>
              </Column>
            </Grid>
          </Form>
        )}
      />
    </Column>
  </Grid>
);

export default ContrattoForm;

ContrattoForm.propTypes = {
  addAction: PropTypes.func,
  //  closeModal: PropTypes.func,
  initialValues: PropTypes.object,
};



// WEBPACK FOOTER //
// ./app/components/Forms/Anagrafica/Collaboratore/contrattoForm.js